import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Global error handler for uncaught errors (e.g. SyntaxError from broken chunks)
window.addEventListener("error", (event) => {
  const { error, message } = event;

  // Handle SyntaxError from broken/stale JS chunks (e.g. "Unexpected token 'export'")
  // This typically happens when the browser loads a cached HTML page that references
  // old JS chunks that no longer exist after a new deployment.
  if (
    error instanceof SyntaxError ||
    message?.includes("SyntaxError") ||
    message?.includes("Unexpected token")
  ) {
    console.error("[GlobalErrorHandler] SyntaxError detected, likely stale cache:", message);

    // Check if we already tried reloading to prevent infinite loops
    const reloadKey = "freeladash_syntax_reload";
    const lastReload = sessionStorage.getItem(reloadKey);
    const now = Date.now();

    if (!lastReload || now - parseInt(lastReload) > 30000) {
      sessionStorage.setItem(reloadKey, now.toString());
      // Force a hard reload to bypass cache
      window.location.reload();
      return;
    }
  }
});

const rootElement = document.getElementById("root");

if (rootElement) {
  createRoot(rootElement).render(<App />);
} else {
  console.error("[main] Root element not found");
}
